module.exports = __webpack_public_path__ + "static/img/elipse.b2eebaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/elipse.png
// module id = ISUR
// module chunks = 3